/* eslint-disable import/no-extraneous-dependencies */
import { createBrowserHistory } from 'history';

export default createBrowserHistory();
